<template>
  <v-layout>
    <v-flex>
      <v-tooltip
        v-if="campsite.campfire ==='1'"
        bottom
      >
        <v-icon
          slot="activator"
          color="red"
        >
          fa-fire
        </v-icon>
        <span>Fires Allowed</span>
      </v-tooltip>
      <v-tooltip
        v-if="campsite.accessible ==='1'"
        bottom
      >
        <v-icon
          slot="activator"
          color="green"
        >
          fa-wheelchair
        </v-icon>
        <span>Accessible</span>
      </v-tooltip>
      <v-tooltip
        v-if="campsite.hiking ==='1'"
        bottom
      >
        <v-icon
          slot="activator"
          color="brown"
        >
          fa-walking
        </v-icon>
        <span>Hike In</span>
      </v-tooltip>
      <v-tooltip
        v-if="campsite.canoe ==='1'"
        bottom
      >
        <v-icon
          slot="activator"
          color="blue"
        >
          rowing
        </v-icon>
        <span>Canoe In</span>
      </v-tooltip>
      <v-tooltip
        v-if="campsite.adminOnly ==='1'"
        bottom
      >
        <v-icon
          slot="activator"
          color="black"
        >
          fa-lock
        </v-icon>
        <span>Admin Only</span>
      </v-tooltip>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    campsite: {
      type: Object,
      default: function () { return {} }
    }
  }
}
</script>
